import React, {useEffect, useState} from 'react';
import {Icon, IconTypes} from '../../elements/Icon/Icon';
import {Input} from '../../elements/Input/Input';
import {Button} from '../../elements/Button/Button';

export const SearchInput: React.FC<{
    searchInputTestId: string;
    clearButtonTestId: string;
    inputAriaLabel: string;
    clearButtonAriaLabel: string;
    placeHolder: string;
    label?: string;
    name?: string;
    onSearchInputChanged: (value: string) => void;
}> = ({
    searchInputTestId,
    clearButtonTestId,
    inputAriaLabel,
    clearButtonAriaLabel,
    placeHolder,
    name = '',
    label = '',
    onSearchInputChanged,
}) => {
    const [searchQuery, setSearchQuery] = useState<string>('');

    useEffect(() => {
        onSearchInputChanged(searchQuery);
    }, [searchQuery, onSearchInputChanged]);

    return (
        <Input
            autoComplete="off"
            colorScheme="light"
            enhancerStart={
                <Icon source={IconTypes.IconSearch} size="compact" />
            }
            enhancerEnd={
                searchQuery !== '' && (
                    <Button
                        aria-label={clearButtonAriaLabel}
                        modifier="square"
                        onClick={() => setSearchQuery('')}
                        size="compact"
                        variant="transparent"
                        data-testid={clearButtonTestId}
                    >
                        <Icon source={IconTypes.IconClose} size="compact" />
                    </Button>
                )
            }
            type="text"
            testId={searchInputTestId}
            className="pb-4"
            placeholder={placeHolder}
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            variant="standard"
            name={name}
            label={label}
            aria-label={inputAriaLabel}
        />
    );
};
